import { AI_API_URL } from '../../constants';

export const extractVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|live\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const fetchVideoTitle = async (url) => {
  try {
    const videoId = extractVideoId(url);
    if (!videoId) {
      throw new Error('올바른 YouTube URL이 아닙니다.');
    }

    const response = await fetch(
      `${AI_API_URL}/api/youtube-title?videoId=${videoId}`
    );

    if (!response.ok) {
      throw new Error('영상 정보를 가져오는데 실패했습니다.');
    }

    const data = await response.json();
    return data.title;
  } catch (error) {
    throw error;
  }
};

export const timeToSec = (str) => {
  const m = str.match(/\[(\d{2}):(\d{2})\]/);
  if (!m) return 0;
  return parseInt(m[1]) * 60 + parseInt(m[2]);
};

export const groupTranscriptBySentence = (transcript) => {
  if (!transcript) return [];
  
  const lines = transcript.split('\n');
  const result = [];
  let current = {
    time: '',
    text: '',
    seconds: 0
  };

  const isEndOfSentence = (text) => {
    if (/[.!?。！？][\s"']*$/.test(text)) return true;
    if (/\.{3,}[\s"']*$/.test(text)) return true;
    if (/[.!?。！？]["""'']*$/.test(text)) return true;
    if (/(?:[요죠죵쥬쥬죠조]|[다까지만요옵죠양함임됨])[\s"']*$/.test(text)) return true;
    return false;
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const match = line.match(/^\[(\d{2}):(\d{2})\]\s*(.*)$/);
    
    if (match) {
      const minutes = parseInt(match[1]);
      const seconds = parseInt(match[2]);
      const time = `[${match[1]}:${match[2]}]`;
      const text = match[3].trim();

      const timeDiff = current.time ? 
        (minutes * 60 + seconds) - current.seconds : 
        0;

      if (!current.time || isEndOfSentence(current.text) || timeDiff > 10) {
        if (current.time && current.text) {
          result.push(current);
        }
        current = {
          time,
          text,
          seconds: minutes * 60 + seconds
        };
      } else {
        current.text += ' ' + text;
      }
    }
  }

  if (current.time && current.text) {
    result.push(current);
  }

  return result;
}; 